export default {
    SuperAdmin: 1,
    Admin: 2,
    Editor: 3,
    User: 4
}